import { render, staticRenderFns } from "./PartnerCourseManagement.vue?vue&type=template&id=297c4070&scoped=true"
import script from "./PartnerCourseManagement.vue?vue&type=script&lang=ts"
export * from "./PartnerCourseManagement.vue?vue&type=script&lang=ts"
import style0 from "./PartnerCourseManagement.vue?vue&type=style&index=0&id=297c4070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c4070",
  null
  
)

export default component.exports